import Footer from "../components/Footer";
import Header from "../components/Header";
import { useGetData } from "../hooks/useGetData";
import { useEffect, useState } from "react";
import { AppPieChart } from "../components/charts/PieChart";
import { Divider } from "@mui/material";

const SentimentAnalysis = () => {
  const { data, loading } = useGetData("sentiment-analysis");
  const [sentimentData, setSentimentData] = useState([]);
  const calculateSentimentTotal = (sentimentData) => {
    const counts = {
      Negative: 0,
      Neutral: 0,
      Positive: 0,
    };

    sentimentData?.forEach(({ sentiment }) => {
      if (sentiment === "negative") counts.Negative += 1;
      else if (sentiment === "neutral") counts.Neutral += 1;
      else if (sentiment === "positive") counts.Positive += 1;
    });

    setSentimentData([
      { name: "Positive", value: counts.Positive },
      { name: "Neutral", value: counts.Neutral },
      { name: "Negative", value: counts.Negative },
    ]);
  };
  const colors = ["#4ADE80", "#A1A1AA", "#F87171"];
  useEffect(() => {
    if (data !== undefined)
      calculateSentimentTotal(data?.sentimentAnalysisData);
  }, [data]);
  return (
    <div className="dark">
      <Header />
      <section
        id="blogs"
        className="bg-white dark:bg-gray-900 pt-0 dark min-h-screen "
      >
        {loading ? (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-80">
            <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="dark:bg-gray-900 py-6 text-white sm:py-6 ">
            <div className="mx-auto w-100 px-6 lg:px-8">
              <div className="mx-auto lg:mx-0">
                <h2 className="text-2xl text-center font-semibold tracking-tight text-pretty text-white sm:text-2xl">
                  Sentiment Analysis
                </h2>
                <p className="mt-2 text-center text-lg/8 text-white">
                  Based on Google Reviews and User Feedback from Bizecho
                </p>
              </div>
            </div>

            <Divider />
            <div className="flex justify-center" style={{ height: "30rem" }}>
              {sentimentData?.length > 0 ? (
                <AppPieChart
                  data={sentimentData}
                  colors={colors}
                  startAngle={180}
                  endAngle={0}
                  innerRadius="60%"
                  outerRadius="80%"
                />
              ) : (
                <div className="h-full flex text-center">
                  <p className="text-white text-center m-auto">No Data</p>
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              {sentimentData?.map((entry) => (
                <div
                  key={entry.name}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <div
                    style={{
                      width: "15px",
                      height: "15px",
                      backgroundColor:
                        entry.name === "Positive"
                          ? colors[0]
                          : entry.name === "Negative"
                          ? colors[2]
                          : colors[1],
                      borderRadius: "3px",
                    }}
                  />
                  <span>
                    {entry.name}: {entry.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};
export default SentimentAnalysis;
